module.exports = __webpack_public_path__ + "img/epharma.fbd657c5.png";